import { AxiosResponse } from "axios";
import Api from "./Api";

export type GenericPermissions = TestRequestRaw.Schemas.GenericPermissions;
export type TestRequestPermissions = TestRequestRaw.Schemas.TestRequestPermissions;
export type TestPlanPermissions = TestRequestRaw.Schemas.TestPlanPermissions;
export type TestSeriesPermissions = TestRequestRaw.Schemas.TestSeriesPermissions;

class PermissionApi {
  constructor(private api: Api) {}

  public fetchGenericPermissions(): Promise<AxiosResponse<GenericPermissions>> {
    return this.api.get(`/test-request/v2/permissions/generic`);
  }

  public fetchTestRequestPermissions(testRequestId: string): Promise<AxiosResponse<TestRequestPermissions>> {
    return this.api.get(`/test-request/v2/permissions/test-request/${testRequestId}`);
  }

  public fetchTestPlanPermissions(testRequestId: string): Promise<AxiosResponse<TestPlanPermissions>> {
    return this.api.get(`/test-request/v2/permissions/test-plan/${testRequestId}`);
  }
}

export default PermissionApi;
